export const FETCH_MY_ORGANIZATION_CONTACTS = 'FETCH_MY_ORGANIZATION_CONTACTS'
export const FETCH_MY_ORGANIZATION_CONTACTS_START =
  'FETCH_MY_ORGANIZATION_CONTACTS_START'
export const FETCH_MY_ORGANIZATION_CONTACTS_SUCCESS =
  'FETCH_MY_ORGANIZATION_CONTACTS_SUCCESS'
export const FETCH_MY_ORGANIZATION_CONTACTS_ERROR =
  'FETCH_MY_ORGANIZATION_CONTACTS_ERROR'
